import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  insightPostId: string;
};

const request = ({ insightPostId }: RequestDataType) => {
  return new ApiClient()
    .delete<ResponseMessageType>(
      `/api/members/insight_posts/${insightPostId}/bookmarks`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisInsightPostsBookmarksDestroy = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
